// ADE Coin icon with adaptive background (white in light, black in dark)
export const AdeCoinIcon = ({ size = 20, className = "" }) => (
  <div
    className={`rounded-full bg-white dark:bg-black flex items-center justify-center overflow-hidden shrink-0 ${className}`}
    style={{ width: size, height: size }}
  >
    <img
      src="/images/ade-coin.jpeg"
      alt="ADE"
      className="w-full h-full object-cover"
    />
  </div>
);

export default AdeCoinIcon;
